import React from 'react';

import StatusIconSmall from '../Icons/StatusSmall';
import isPresent from '../Utils/Present';

type Props = {
  title: string,
  values: string[] | string | boolean
};

const FilterCardTitle = (props: Props) => (
  <span>
    {isPresent(props.values) && <StatusIconSmall enabled={isPresent(props.values)} />} {props.title}
  </span>
);

export default FilterCardTitle;



// WEBPACK FOOTER //
// ./src/views/Common/FilterComponents/FilterCardTitle.tsx